import httpSvc from './HttpSvc'
import { DS_ROUTES } from '@/core/constants'

export async function createNomination(data) {
  const nomination = await httpSvc.post(DS_ROUTES.purple_ribbon_awards_nomination_add, data)
  return nomination.data.id
}

export async function getNomination(id) {
  const nomination = await httpSvc.post(DS_ROUTES.purple_ribbon_awards_nomination_get, { id })
  return {...nomination.data.nomination, ...nomination.data.organization_size_name_data, submitted: nomination.data.submitted}
}

export function updateNomination(data) {
  return httpSvc.post(DS_ROUTES.purple_ribbon_awards_nomination_update, data)
}
